import React from "react";
import useField, { useFieldProps } from "src/hooks/form/useField";
import SailingSchedule from "./SailingSchedule";

const useSailingSchedule = (props: useFieldProps<{
  isMandatory: boolean,
  shipmentExecutionId: string,
}>) => {
  const { isMandatory, shipmentExecutionId } = props.extraData || {};
  const formOptions = isMandatory ? {
    rules: [
      {
        validator: (rule, value, callback) => {
          if (value) {
            if (!value?.showInputFields || (value?.vesselName?.length && value?.originDepartureDate)) {
              return callback();
            }
            return callback('Sailing Date and Vessel Name are mandatory.');
          }
          return callback('Please enter all the mandatory fields.');
        }
      }
    ],
  } : props.formOptions;

  const field = useField({
    ...props,
    formOptions, 
  });

  const decorator = (child: React.ReactElement): React.ReactNode => {
    return field.decorator(
      React.createElement(SailingSchedule, {
        ...child.props,
        shipmentExecutionId,
      })
    );
  };

  return {
    ...field,
    decorator,
  };

};

export default useSailingSchedule;
